
import React from 'react';
import { Key, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';

interface ApiKeysTabProps {
  editing: boolean;
}

export const ApiKeysTab: React.FC<ApiKeysTabProps> = ({ editing }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="space-y-0.5">
          <div className="flex items-center">
            <Key className="h-5 w-5 mr-2 text-primary" />
            <h3 className="font-medium text-lg">API Key Management</h3>
          </div>
          <p className="text-muted-foreground text-sm">
            Generate and manage API keys for system integration
          </p>
        </div>
      </div>
      
      <Separator />
      
      <div className="grid gap-4">
        <div className="grid gap-2">
          <Label htmlFor="api-key">System API Key</Label>
          <div className="flex">
            <Input 
              id="api-key" 
              value="••••••••••••••••••••••••••••••"
              type="password"
              readOnly
              className="flex-1"
            />
            <Button 
              variant="outline" 
              className="ml-2" 
              disabled={!editing}
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Regenerate
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            This key provides access to the system API. Keep it secure.
          </p>
        </div>
      </div>
    </div>
  );
};
